import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UxService } from '~/app/core/services';
import { RoleService } from '../../core/services';
import { Folder } from '../models/folder.model';
import { DriveApiBase } from './drive-api.base';
import { EncryptionDecryptionService } from '~/app/services/encryptDecrypt/encryption-decryption.service';

@Injectable()
export class FolderService extends DriveApiBase<Folder> {

  constructor(
    http: HttpClient, 
    roleService: RoleService, 
    encryptDecryptService: EncryptionDecryptionService,
    uxService: UxService
  ) {
    super('folders', http, roleService, encryptDecryptService, uxService);
  }

}
